<template lang="html">
    <div>

    <section class="formulario-momento-ganador -direccion row-center">

        <p>¡FELICIDADES!</p>
            <p>Completa el siguiente formulario para entregarte tu premio</p>

            <div class="row-start">


            <div class="contenedor-input">
                <input type="text" placeholder="Dirección" v-validate="'required|min:3'" v-model="direccion.direccion"
                    name="direccion">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('direccion')
                    }}</span>
            </div>

            <div class="contenedor-input">
                <input type="text" placeholder="Población" v-validate="'required|min:3'" v-model="direccion.poblacion"
                    name="poblacion">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('poblacion')
                    }}</span>
            </div>


            <div class="contenedor-input">
                <input type="text" placeholder="Código Postal" v-validate="'required|length:5'" v-model="direccion.cp" name="cp"
                    >
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('cp') }}</span>
            </div>

            <div class="contenedor-input">
                <input type="text" placeholder="Teléfono" v-validate="'required|integer|min:9'" v-model="direccion.telefono"
                    name="telefono" @keyup.enter="validatedireccion">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono')
                    }}</span>
            </div>

            <div class="contenedor-boton">
                <a class="btn" @click="validatedireccion" :loading="loading">Enviar</a>
            </div>

        </div>
        

    </section>

</div>

</template>

<script lang="js">

    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'formulario-datos-direccion',
        data() {
            return {
                showanimation: false,
                clicked: false,
                loading : false,
                direccion: {
                    email: "",
                    direccion: "",
                    poblacion: "",
                    telefono: "",
                    idProvincia: ''
                }
            }
        },
        mounted() {
            setTimeout(e => {
                this.showanimation = true;
            }, 1000)
        },
        computed: {
            ...mapGetters({
                provincias: 'getProvincias'
            })
        },
        methods: {
            ...mapActions(['sendDatosPersonales']),
            validatedireccion: function () {
                this.clicked = true;
                this.$validator.validateAll().then(canSend => {
                    if (canSend) {
                        this.loading = true;
                        this.sendDatosPersonales(this.direccion)
                            .then(result => {
                                if(result){
                                    this.$emit('complete');
                                }
                                this.loading = false;
                            });
                    }
                });
            },
        }

    }
</script>


<style lang="scss" scoped>



.wrapper-view.-momento-ganador .formulario-momento-ganador .contenedor-input input, 
.wrapper-view.-momento-ganador .formulario-momento-ganador .contenedor-input select,
.wrapper-view.-momento-ganador .formulario-momento-ganador .contenedor-input textarea{
    padding-left: 10px;
    background: white;
}

.wrapper-view.-momento-ganador .formulario-momento-ganador.-direccion{
    margin-top: 0;
    margin-bottom: 40px;

    .contenedor-input.-full{
        width: 100%;
        margin-right: 0;
        max-width: 100%;
    }

}


@media screen and (min-width: 768px){
    
    /* .wrapper-view.-momento-ganador .formulario-momento-ganador .contenedor-input:nth-child(2n){
        margin-right: 30px;
    }
    
    .wrapper-view.-momento-ganador .formulario-momento-ganador .contenedor-input:nth-child(2n-1),
    .wrapper-view.-momento-ganador .formulario-momento-ganador .contenedor-input:last-of-type{
        margin-right: 0px;
    } */

}





</style>


// WEBPACK FOOTER //
// src/components/view-parts/momento-ganador/datos-direccion.vue